import { homepage } from "./homepage"
import { about } from "./about"
import { _header } from "./_header"

export const initGsap = function (){
    _header();

    homepage()
    about()
}